import {get} from 'lodash-es';

const storeKey = 'v2.services.objects.districtConfiguration';

/**
 * @param {Object} state
 * @returns {Object}
 */
export const getDistrictConfiguration = (state) => get(state, storeKey);

/**
 * @param {Object} state
 * @returns {Boolean}
 */
export const isDistrictConfigurationLoading = (state) => get(state, `${storeKey}.isLoading`);
